import React, { useState } from 'react';

import { MESSAGE_MODALS } from '../../context/custom/MessageModalContext';
import { ALERT_TYPE, REQUEST_METHOD, ShowToastMessage } from '@laramie/ui';
import { APIS } from '../../config/apis';
import { PERMISSIONS } from '../../consts/permissions';
import { ServerRequest } from '../../utils/apiweb';
import { TableCustom, SectionHeading, InputLista } from '../../components/common';
import ClaseElementoModal from '../../components/controls/ClaseElementoModal';
import { useLista, useManagedContext } from '../../components/hooks';
import { standardRequest } from '../../utils/requests';



function ClaseElementoView() {
    const { setIsLoading, showMessageModal } = useManagedContext()

    //hooks
    const [state, setState] = useState({
        showForm: false,
        modeFormEdit: false,
        rowId: 0,
        list: []
    });

    const [idTipoTributoState, setTipoTributoState] = useState(0)

    const [, getRowLista ] = useLista({
        listas: ['TipoTributo'],
        memo: {
          key: 'TipoTributo',
          timeout: 0
        }
    });

    const getDescTipoTributo = (id) => {
        const row = getRowLista('TipoTributo', id);
        return (row) ? row.nombre : 'Todos los tributos';
    }

    //definiciones
    const tableColumns = [
        { Header: 'Tipo de tributo', Cell: (props) => {
            const row = props.row.original;
            const tipoTributo = getDescTipoTributo(row.idTipoTributo);
            return tipoTributo;
          }, id: 'tipoTributo', accessor: 'id', width: '10%' },
        { Header: 'Código', accessor: 'codigo', width: '25%' },
        { Header: 'Orden', accessor: 'orden', width: '20%' },
        { Header: 'Nombre', accessor: 'nombre', width: '20%' },
        { Header: 'Ejecución periódica', accessor: 'ejecucionPeriodica', width: '20%' , Cell: (props) => {
            const row = props.row.original;
            return (row.ejecucionPeriodica) ? 'Sí' : 'No';
        }}, 
    ];


    //handles
    const avmr = {
        onAdd: () => {
            setState(prevState => ({...prevState, showForm: true, modeFormEdit: true, rowId: 0}))
        },
        onView: ({ id }) => {
            setState(prevState => ({...prevState, showForm: true, modeFormEdit: false, rowId: parseInt(id)}))
        },
        onModify: ({ id }) => {
            setState(prevState => ({...prevState, showForm: true, modeFormEdit: true, rowId: parseInt(id)}))
        },
        onRemove: ({ id }) => {
            const item = state.list.find(x => x.id === id)
            showMessageModal({
                ...MESSAGE_MODALS.BORRAR,
                message: `¿Está seguro de borrar la clase ${item.nombre}?`,
                onConfirm: () => {
                    setIsLoading(true)
                    standardRequest(REQUEST_METHOD.DELETE, `${APIS.URLS.CLASE_ELEMENTO}/${id}`)
                    .then(() => SearchClasesElementos(idTipoTributoState))
                    .catch(() => {})
                    .finally(() => setIsLoading(false))
                }
            })
        },
    }

    //callbacks
    const callbackNoSuccess = (response) => {
        response.json()
        .then((error) => {
          const message = error.message;
          ShowToastMessage(ALERT_TYPE.ALERT_ERROR, message);
          setIsLoading(false)
        })
        .catch((error) => {
            const message = 'Error procesando respuesta: ' + error;
            ShowToastMessage(ALERT_TYPE.ALERT_ERROR, message);
            setIsLoading(false)
        });
    }
    const callbackError = (error) => {
        const message = 'Error procesando solicitud: ' + error.message;
        ShowToastMessage(ALERT_TYPE.ALERT_ERROR, message);
        setIsLoading(false)
    }

    //funciones

    function SearchClasesElementos(idTipoTributo){
        setTipoTributoState(idTipoTributo);                        
        setIsLoading(true)
        setState(prev => ({ ...prev, list: [], }))

        const callbackSuccess = (response) => {
            response.json()
            .then((data) => {
                setIsLoading(false)
                setState(prev => ({ ...prev, list: data }))
            })
            .catch((error) => {
                const message = 'Error procesando respuesta: ' + error;
                ShowToastMessage(ALERT_TYPE.ALERT_ERROR, message);
                setIsLoading(false)
            });
        };

        const paramsUrl = `/tipo-tributo/${idTipoTributo}`;

        ServerRequest(
            REQUEST_METHOD.GET,
            null,
            true,
            APIS.URLS.CLASE_ELEMENTO,
            paramsUrl,
            null,
            callbackSuccess,
            callbackNoSuccess,
            callbackError
        );

    }

    return (
    <>
        {state.showForm && 
            <ClaseElementoModal
                id={state.rowId}
                idTipoTributo={idTipoTributoState}
                disabled={!state.modeFormEdit}
                onDismiss={() => {
                    setState(prevState => {
                        return {...prevState, showForm: false};
                    });
                }}
                onConfirm={(id) => {
                    setState(prevState => {
                        return {...prevState, showForm: false, rowId: 0};
                    });

                    SearchClasesElementos(idTipoTributoState);
                }}
            />
        }

        <SectionHeading titles={[{ title: 'Configuración' }, { title: 'Administración de clases'}]} />

        <section className='section-accordion'>
            <div className="m-top-20">
                <div className='row form-basic'>
                    <div className="col-3">
                        <label htmlFor="idTipoTributo" className="form-label">Tipo de tributo</label>
                        <InputLista
                            name="idTipoTributo"
                            placeholder=""
                            className="form-control"
                            value={idTipoTributoState}
                            title="Tipo tributo"
                            lista="TipoTributo"
                            onChange={({ target })  =>{
                                let idTipoTributo = 0;
                                if (target.row) {
                                    idTipoTributo = parseInt(target.value);
                                }

                                SearchClasesElementos(idTipoTributo);
                            }}
                        />
                    </div>
                </div>
                <div className="m-top-20">

                {idTipoTributoState !== 0 && (
                    <TableCustom
                        className={'TableCustomBase m-top-20'}
                        columns={tableColumns}
                        data={state.list}
                        avmr={avmr}
                        editCode={PERMISSIONS.LISTAS_INGRESOS_PUBLICOS_EDIT}
                        messageEmpty="No se encontraron resultados"
                    />
                )}

                </div>
            </div>
        </section>
        
    </>
    )
}

export default ClaseElementoView;
